var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-button',{attrs:{"fill":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit("click", $event)}}},[_c('div',{staticClass:"button-box"},[_c('svg-icon',{attrs:{"icon":"filter"}}),_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }